"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const DEFAULT_CURRENCY_1 = __importDefault(require("../../../constants/date/DEFAULT_CURRENCY"));
const LANG_1 = __importDefault(require("../../../constants/lang/LANG"));
const fleetGroupFactory_1 = __importDefault(require("../../fleetgroup/fleetGroupFactory"));
const formatPriceValue_1 = __importDefault(require("../../utils/common/formatPriceValue"));
const formatPriceWithoutDecimals_1 = __importDefault(require("../../utils/common/formatPriceWithoutDecimals"));
const formatWithoutDecimals_1 = __importDefault(require("../../utils/common/formatWithoutDecimals"));
/**
 * Returns formatted fleet price info
 * @param {FleetPriceType} fleetPrice
 * @param {string} language
 * @returns {FleetPriceFactoryType}
 */
function fleetPriceFactory(fleetPrice, language = LANG_1.default.EN) {
    var _a, _b;
    const currency = (0, get_1.default)(fleetPrice, 'currency', DEFAULT_CURRENCY_1.default);
    const pricePerDay = (0, get_1.default)(fleetPrice, 'pricePerDay');
    // const sortPrice = Number((pricePerDay * 1).toFixed(0)); // to-do: will do rounding - product?
    const formattedPrice = (0, formatPriceWithoutDecimals_1.default)(`${pricePerDay}`);
    const displayPrice = `${formattedPrice} ${currency}`;
    const vatPercentage = Number((0, get_1.default)(fleetPrice, 'vatPercentage'));
    const allDiscountDetails = (0, get_1.default)(fleetPrice, 'priceDetails.allDiscountDetails', {});
    const onlineDiscountDetails = (0, get_1.default)(fleetPrice, 'priceDetails.onlineDiscountDetails', {});
    const hasAllDiscount = !(0, isEmpty_1.default)(allDiscountDetails);
    const hasOnlineDiscount = !(0, isEmpty_1.default)(onlineDiscountDetails);
    let sortPrice;
    sortPrice = Number((pricePerDay * 1).toFixed(0)); // to-do: will do rounding - product?
    if (hasAllDiscount) {
        const allDiscountPerDayPrice = (0, get_1.default)(allDiscountDetails, 'pricePerDay');
        sortPrice = Number((allDiscountPerDayPrice * 1).toFixed(0));
    }
    if (hasOnlineDiscount) {
        const onlineDiscountPerDayPrice = (0, get_1.default)(onlineDiscountDetails, 'pricePerDay');
        sortPrice = Number((onlineDiscountPerDayPrice * 1).toFixed(0));
    }
    const hasAutoAppliedPromo = hasAllDiscount || hasOnlineDiscount;
    // TODO: get pricePerDayWithVAT using the API once backend is ready
    // For now just to use it for AB test we are calculating the value at frontend side
    // https://data4altayyargroup.atlassian.net/browse/LUM-75
    const vatPerDay = pricePerDay * (vatPercentage / 100);
    const pricePerDayWithVAT = pricePerDay + vatPerDay;
    const formattedPricePerDayWithVAT = (0, formatPriceWithoutDecimals_1.default)(`${pricePerDayWithVAT}`);
    const groupId = (0, get_1.default)(fleetPrice, 'groupId', -1);
    const parentGroupId = ((_b = (_a = fleetPrice === null || fleetPrice === void 0 ? void 0 : fleetPrice.group) === null || _a === void 0 ? void 0 : _a.parentCarGroup) === null || _b === void 0 ? void 0 : _b.id) || groupId;
    const group = (0, fleetGroupFactory_1.default)(fleetPrice.group, language);
    const returnObj = {
        parentGroupId,
        available: (0, get_1.default)(fleetPrice, 'available', false),
        cdwPerDay: (0, get_1.default)(fleetPrice, 'cdwPerDay'),
        currency,
        extCarGroup: (0, get_1.default)(fleetPrice, 'extCarGroup', ''),
        finalPrice: (0, formatPriceValue_1.default)((0, get_1.default)(fleetPrice, 'finalPrice'), currency),
        displayPricePerDayWitVAT: (0, formatPriceValue_1.default)(formattedPricePerDayWithVAT, currency),
        groupId,
        group,
        soldDays: (0, formatWithoutDecimals_1.default)(`${(0, get_1.default)(fleetPrice, 'soldDays', '')}`),
        vatPercentage: `${vatPercentage.toFixed(0)}%`,
        vat: (0, formatPriceValue_1.default)((0, get_1.default)(fleetPrice, 'priceDetails.vat'), currency),
        rental: (0, formatPriceValue_1.default)((0, get_1.default)(fleetPrice, 'priceDetails.rentalSum'), currency),
        extra: (0, formatPriceValue_1.default)((0, get_1.default)(fleetPrice, 'priceDetails.extraSum'), currency),
        cdw: (0, formatPriceValue_1.default)((0, get_1.default)(fleetPrice, 'priceDetails.cdw'), currency),
        displayPrice,
        sortPrice,
        hasAutoAppliedPromo,
        hasOnlineDiscount,
        hasAllDiscount,
        promoted: (0, get_1.default)(fleetPrice, 'promoted', false),
        pricePerDay: (0, get_1.default)(fleetPrice, 'pricePerDay'),
        pricePerDayInclVat: (0, get_1.default)(fleetPrice, 'pricePerDayInclVat'),
    };
    // add a discount property if there is auto applied promo
    if (hasAutoAppliedPromo) {
        let discountObject = {};
        // find out which discount to pick up
        if (hasAllDiscount) {
            discountObject = Object.assign({}, allDiscountDetails);
        }
        // online discount takes priority
        if (hasOnlineDiscount) {
            discountObject = Object.assign({}, onlineDiscountDetails);
        }
        const discountedPricePerDay = (0, get_1.default)(discountObject, 'pricePerDay');
        const formattedPrice = (0, formatPriceWithoutDecimals_1.default)(`${discountedPricePerDay}`);
        const displayPrice = `${formattedPrice} ${currency}`;
        const vatPerDay = discountedPricePerDay * (vatPercentage / 100);
        // TODO: same comment to get from API
        const pricePerDayWithVAT = discountedPricePerDay + vatPerDay;
        const formattedPricePerDayWithVAT = (0, formatPriceWithoutDecimals_1.default)(`${pricePerDayWithVAT}`);
        returnObj.discount = {
            displayPrice,
            vat: (0, formatPriceValue_1.default)((0, get_1.default)(discountObject, 'vat'), currency),
            rental: (0, formatPriceValue_1.default)((0, get_1.default)(discountObject, 'rentalSum'), currency),
            finalPrice: (0, formatPriceValue_1.default)((0, get_1.default)(discountObject, 'finalPrice'), currency),
            displayPricePerDayWitVAT: (0, formatPriceValue_1.default)(formattedPricePerDayWithVAT, currency),
            discountPercent: (0, get_1.default)(discountObject, 'promotionSummary.discount', 0),
            promoCode: (0, get_1.default)(fleetPrice, 'priceDetails.promotionDetails.code', ''),
        };
    }
    return returnObj;
}
exports.default = fleetPriceFactory;
